import { EventEmitter } from 'events';

export default new class AudioPlayer extends EventEmitter {

  private _audios: { [key: string]: HTMLAudioElement } = {};
  private _url: string|null = null;
  private _playing: boolean = false;

  constructor() {
    super();
    this.setMaxListeners(0);
  }

  addPlaybackStateObserver(callback: () => void) {
    this.on('change', callback);
  }

  removePlaybackStateObserver(callback: () => void) {
    this.removeListener('change', callback);
  }

  load(url: string): void {
    if (!this._audios[url]) {
      const time = new Date().getTime();
      const delimiter = (url.indexOf('?') < 0 ? '?' : '&');
      const audio = new Audio(`${url + delimiter}rand=${time}`);
      audio.preload = 'metadata';
      audio.load();
      this._audios[url] = audio;
    }
  }

  play(url: string): void {
    this.load(url);
    this.pause();
    this._url = url;
    this._playing = true;
    this._audios[this._url].play();
    this.emit('change');
  }

  pause(): void {
    if (this._url && this._audios[this._url] && this._playing) {
      this._audios[this._url].pause();
      this._url = null;
      this._playing = false;
      this.emit('change');
    }
  }

  isPlaying(): boolean {
    return this._playing;
  }

  getPlayingUrl(): string|null {
    return this._url;
  }

  getCurrentPosition(): number {
    if (this._url === null) return 0;
    const audio = this._audios[this._url];
    return audio ? audio.currentTime || 0 : 0;
  }

  getDuration(): number {
    if (this._url === null) return 0;
    const audio = this._audios[this._url];
    return audio ? audio.duration || 0 : 0;
  }

  setCurrentPosition(position: number): void {
    if (this._url === null) return;
    if (isNaN(position)) return;
    const audio = this._audios[this._url];
    if (audio) {
      audio.currentTime = position;
    }
  }
}();
